module.exports = __webpack_public_path__ + "kudos_14.svg?2a2ce06171c0aa9e7bc0cba79fb28f75";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_14.svg
// module id = 111
// module chunks = 0